<mode-code-highlight
  *ngIf="rawQuery && renderedQuery"
  lang="sql"
  [lineNumbers]="true"
  [query]="isRawQuery ? rawQuery : renderedQuery"
></mode-code-highlight>
